import { Comment } from '../models/comment.model';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Reaction } from '../models/reaction.model';
import * as i0 from "@angular/core";
import * as i1 from "./feathers.service";
import * as i2 from "./api.service";
var CommentService = /** @class */ (function () {
    function CommentService(feathers, apiService) {
        this.feathers = feathers;
        this.apiService = apiService;
        this._fsServiceName = "comments";
        this._createdComment = new BehaviorSubject(null);
        this._updatedComment = new BehaviorSubject(null);
        this.setCreatedCommentEvent();
        this.setUpdatedCommentEvent();
    }
    CommentService.prototype.onCreatedComment = function () {
        return this._createdComment;
    };
    CommentService.prototype.createComment = function (data) {
        return this.apiService.post(this._fsServiceName, data).pipe(map(function (comment) { return new Comment().deserialize(comment); }));
    };
    CommentService.prototype.setCreatedCommentEvent = function () {
        var _this = this;
        this.feathers.client.service(this._fsServiceName).on('created', function (comment) {
            _this._createdComment.next(new Comment().deserialize(comment));
            _this._createdComment.next(null);
        });
    };
    CommentService.prototype.onUpdatedComment = function () {
        return this._updatedComment;
    };
    CommentService.prototype.updateComment = function (id, data) {
        return this.apiService.put(this._fsServiceName, id, data).pipe(map(function (comment) { return new Comment().deserialize(comment); }));
    };
    CommentService.prototype.setUpdatedCommentEvent = function () {
        var _this = this;
        this.feathers.client.service(this._fsServiceName).on('updated', function (comment) {
            _this._updatedComment.next(new Comment().deserialize(comment));
            _this._updatedComment.next(null);
        });
    };
    CommentService.prototype.getCommentReactions = function (token, params) {
        if (params === void 0) { params = {}; }
        var defaultParams = {
            query: {
                operationPath: '/reactions'
            }
        };
        Object.assign(defaultParams.query, params);
        return this.apiService.get(this._fsServiceName, token, defaultParams).pipe(map(function (reactions) {
            reactions.forEach(function (value, index) {
                reactions[index] = new Reaction().deserialize(value);
            });
            return reactions;
        }));
    };
    CommentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommentService_Factory() { return new CommentService(i0.ɵɵinject(i1.FeathersService), i0.ɵɵinject(i2.ApiService)); }, token: CommentService, providedIn: "root" });
    return CommentService;
}());
export { CommentService };
